import { State } from './types'

export const initialState: State = {
  isLoading: false,
  zone: {
    totalCount: 0,
    avgPrice: 0,
    avgM2Price: 0,
    avgSurface: 0,
  },
}